import O from "./O";
import { useMemo, useContext, useState } from 'react';
import { NodeBoundsContext } from './Contexts';

export default function NodeBoundsContextWrapper({children}){

  const [ changes, setChanges ] = useState();

  const value = useMemo(() => {
    return { changes, setChanges }
  },[changes,setChanges])



  return (
    <NodeBoundsContext.Provider value={value}>
      {false && <div style={{
        position:'fixed',
        background:'black',
        top:0,
        left:0,
        width:300,
        height:300,
        color:'lime',
        zIndex:1000,
      }}>
        <O>{value}</O>
      </div>}
      {children}
    </NodeBoundsContext.Provider>
  )
}
